import firebase from 'firebase';

let config, publicUrl;
let currentUrl = window.location.href;


if (currentUrl.indexOf("setec-cloud.firebaseapp.com") != -1) {
  config = {
    apiKey: "AIzaSyCbB6BUTGHJGbTlP2OI-EB1am5Qsl-uU7g",
    authDomain: "setec-cloud.firebaseapp.com",
    databaseURL: "https://setec-cloud.firebaseio.com",
    projectId: "setec-cloud",
    storageBucket: "setec-cloud.appspot.com",
    messagingSenderId: "396511023292",
  };
  publicUrl = 'https://setec-cloud.firebaseapp.com';
} else if (currentUrl.indexOf("emive-rediseg-48554.firebaseapp.com")  != -1) {
  config = {
    apiKey: "AIzaSyD1knCtUiR7xomL7kc23ClKmKj4XAeWp4Q",
    authDomain: "emive-rediseg-48554.firebaseapp.com",
    databaseURL: "https://emive-rediseg-48554.firebaseio.com",
    projectId: "emive-rediseg-48554",
    storageBucket: "emive-rediseg-48554.appspot.com",
    messagingSenderId: "396511023292",
  };
  publicUrl = 'https://emive-rediseg-48554.firebaseapp.com';
} else if (currentUrl.indexOf("rediseg-atent.firebaseapp.com")  != -1) {
  config = {
    apiKey: "AIzaSyBUmWG3sJd73OK46nVa_eB_OiHgPpUTeBo",
    authDomain: "rediseg-atent.firebaseapp.com",
    databaseURL: "https://rediseg-atent.firebaseio.com",
    projectId: "rediseg-atent",
    storageBucket: "rediseg-atent.appspot.com",
    messagingSenderId: "396511023292",
  };
  publicUrl = 'https://rediseg-atent.firebaseapp.com';
} else if (currentUrl.indexOf("rediseg-bhcam.firebaseapp.com")  != -1) {
  config = {
    apiKey: "AIzaSyDcIJKE9u2n74q_isI1v33DuJoqDOhzRns",
    authDomain: "rediseg-bhcam.firebaseapp.com",
    databaseURL: "https://rediseg-bhcam.firebaseio.com",
    projectId: "rediseg-bhcam",
    storageBucket: "rediseg-bhcam.appspot.com",
    messagingSenderId: "366037948930",
  };
  publicUrl = 'https://rediseg-sisak.firebaseapp.com';
} else if (currentUrl.indexOf("rediseg-sisak.firebaseapp.com")  != -1) {
  config = {
    apiKey: "AIzaSyDgyKTLB7vTLvvEnGt0WS9wfY9FggQ_8DU",
    authDomain: "rediseg-sisak.firebaseapp.com",
    databaseURL: "https://rediseg-sisak.firebaseio.com",
    projectId: "rediseg-sisak",
    storageBucket: "rediseg-sisak.appspot.com",
    messagingSenderId: "366037948930",
  };
  publicUrl = 'https://rediseg-sisak.firebaseapp.com';
} else if (currentUrl.indexOf("localhost")  != -1) {
  config = {
    apiKey: "AIzaSyDgyKTLB7vTLvvEnGt0WS9wfY9FggQ_8DU",
    authDomain: "rediseg-sisak.firebaseapp.com",
    databaseURL: "https://rediseg-sisak.firebaseio.com",
    projectId: "rediseg-sisak",
    storageBucket: "rediseg-sisak.appspot.com",
    messagingSenderId: "366037948930",
  };
  publicUrl = 'https://rediseg-sisak.firebaseapp.com';
  // config = {
  //   apiKey: "AIzaSyCbB6BUTGHJGbTlP2OI-EB1am5Qsl-uU7g",
  //   authDomain: "setec-cloud.firebaseapp.com",
  //   databaseURL: "https://setec-cloud.firebaseio.com",
  //   projectId: "setec-cloud",
  //   storageBucket: "setec-cloud.appspot.com",
  //   messagingSenderId: "396511023292",
  // };
  // publicUrl = 'https://setec-cloud.firebaseapp.com';
} 

firebase.initializeApp(config);

export default firebase;
export const FIREBASE_PUBLIC_URL = publicUrl;



// WEBPACK FOOTER //
// ./src/util/firebase.js